export enum LoanApplicationCapability {
  VIEW = 'VIEW',
  OPEN_PROCESS_RESPONSE_FOLDER = 'OPEN_PROCESS_RESPONSE_FOLDER',
  CHANGE_LENDER_APPROVAL_STATUS = 'CHANGE_LENDER_APPROVAL_STATUS',
  SET_LENDER_REQUEST_ID = 'SET_LENDER_REQUEST_ID',
  SET_CONTRACT_SIGNED = 'SET_CONTRACT_SIGNED',
  CONTRACT_SIGNATURE_TO_BORROWER_SENDING = 'CONTRACT_SIGNATURE_TO_BORROWER_SENDING',
  UN_SIGN_CONTRACT = 'UN_SIGN_CONTRACT',
}
